/**
 * User: Rob Richard
 * Date: 12/20/13
 * Time: 4:49 PM
 */

"use strict";

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('../SoaModel');
var Address = require('../Address');
var AddressBook = SoaModel.extend();
var endpoints = require('dibs-endpoints');

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var filterByFn = function (fn) {
    var list = this.get('addressList');
    if (list) {
        return list.filter(function (address) {
            return address[fn]();
        });
    }
};

module.exports = bunsen.AddressBook = AddressBook;

_.extend(AddressBook.prototype, {
    /*
    TODO: define an accessor method for `this.parents[0]` -- perhaps in SoaModel

    note: this model isn't guaranteed to have a `this.parent` property

    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.addressBook(this.parents[0].id);
    },
    */

    url: endpoints.addressBook,
    idAttribute: "id",
    relations: [
        {
            key: 'addressList',
            relatedModel: Address,
            type: Backbone.Many
        }
    ],
    getAddressById: function (id) {
        return this.get('addressList').findWhere({id: id});
    },
    getPersonalAddress: function () {
        return this.getAddressById(this.get('personalAddressId'));
    },
    getProAddress: function () {
        return this.getAddressById(this.get('proAddressId'));
    },
    getFirstShippingAddress: function () {
        return _.first(this.getShippingAddresses());
    },
    getShippingAddresses: _.partial(filterByFn, 'isValidShippingAddress'),
    getBillingAddresses: _.partial(filterByFn, 'isValidBillingAddress')
});

_.extend(AddressBook, {
    getNewAddressBook: function () {
        return new AddressBook({
            addressList: []
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/AddressBook.js
// module id = 2040
// module chunks = 62